import LoaderElem from '@components/svg/LoaderSvg'
import React from 'react'
import styled from 'styled-components'

const LoaderWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
  svg {
    width: 70px;
  }
`

const Loader = ({ fillOne, fillTwo, fillThree }) => {
  return (
    <LoaderWrap>
      <LoaderElem fillOne={fillOne} fillThree={fillThree} fillTwo={fillTwo} />
    </LoaderWrap>
  )
}

export default Loader
